export default __webpack_public_path__ + "34f83fbe084b705771a5f5e27abf2a80.svg";